/*

Creating a preamp asset to update feature flags on the fly?
Check out the following example:

var checkApp = setInterval(function() {
  if (typeof(window.setFlag) != 'undefined') {
    window.setFlag('useBrandedRowV2', true);
    clearInterval(checkApp);
  }
}, 10);

*/

import { SetFeatureFlagPayload } from 'types/featureFlag'
import { Action, action } from 'easy-peasy'
import store from 'store'

globalThis.setFlag = function (name, value) {
  store.getActions().featureFlags.setFlag({ name, value })
}

export interface FeatureFlagsModel {
  flags: { [key: string]: unknown }
  setFlag: Action<FeatureFlagsModel, SetFeatureFlagPayload>
}

const featureFlags: FeatureFlagsModel = {
  flags: {
    /* Hides tabs and shows all results */
    allResultsHideTabs: !globalThis.location.href.includes('allResultsHideTabs=false'),
    /* Changes the name of the offer badge label */
    brSelectCallOutText: 'Featured',
    /* Changes the select description text in the tabbed section */
    brSelectDescriptionText:
      '"Featured lenders" are select members of our lending network who consistently appear on our rate table and offer a variety of product options.',
    /* Changes the text of the CTA inside the offer row */
    CTAText: 'Next',
    /** forces low coverage extra offers to show */
    forceExtraOffers: globalThis.location.href.includes('extra=true'),
    /** shows an alternative call button */
    showAltPhoneBtn: globalThis.location.href.includes('altPhoneCallBtn=true') || true,
    includeFhaAutomatically: false,
    useQaGateway: window.location.href.includes('useQaGateway=true'),
    useProdGateway: window.location.href.includes('useQaGateway=false'),
    /** shows CTR banner text variations */
    showCTRBanner1: window.location.href.includes('showCTRBanner1=true'),
    showCTRBanner2: window.location.href.includes('showCTRBanner2=true'),
    showCTRBanner3: window.location.href.includes('showCTRBanner3=true'),
    hideFeaturedBadge: window.location.href.includes('hideFeaturedBadge=true') || true,
    hidePremierBadge: window.location.href.includes('hidePremierBadge=true') || true,
    elf: window.location.href.includes('elf=true'),
    enableMortgageApi: true,
    enableLcl: window.location.href.includes('enableLcl=true'),
    showHelpDesk: window.location.href.includes('showHelpDesk=true'),
    hideBrSelectText: false,
    showStackedOffers: false, // used to be globalThis.showStackedOffers
    advertiserOfferLimit: process.env.REACT_APP_ADVERTISER_OFFER_LIMIT,
    enableSageSponsored: globalThis.enableSageSponsored || window.location.href.includes('enableSageSponsored=true'),
    hideUpfrontCosts: false,
    hideMobileFiltersClose: globalThis.hideMobileFiltersClose || false,
    rateBidderStates: [],
    showLeftRailFilters: window.location.href.includes('showLeftRailFilters=true'),
    testMode: window.location.href.includes('testMode=true'),
    advertiserDisclosureText: window.location.href.includes('advertiserDisclosureText=true'),
  },
  setFlag: action((state, payload) => {
    state.flags[payload.name] = payload.value
  }),
}

export default featureFlags
